import { applyMiddleware, combineReducers, compose, createStore, Store } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import history from '../history'

// Types
import { IStoreState } from './types'
import snackbarReducer from '../ducks/snackbar/reducer'
import uiReducer from '../ducks/ui/reducer'

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const enhancers = composeEnhancers(applyMiddleware(routerMiddleware(history)))

const reducers = {
  router: connectRouter(history),
  snackbar: snackbarReducer,
  ui: uiReducer,
}

const rootReducer = combineReducers(reducers)

const store: Store<IStoreState> = createStore(rootReducer, enhancers)

export default store
